/**
 * Scanner feedback side-effects — audio blip, haptic vibration, transient UI message.
 * Pulled out of BarcodeScanner so the scanner file can focus on camera + detection
 * lifecycle (which MUST stay co-located; see the file-level comment in BarcodeScanner.jsx).
 */

let _audio = null;

export function playSuccessSound() {
  try {
    if (!_audio) {
      _audio = new Audio(
        // Short "chirp" WAV — inlined base64 so no network round-trip on first scan
        'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBjGH0fPTgjMGHWu58+CVRAsMTKXh8bllHAU+l'
      );
      _audio.volume = 0.3;
    }
    _audio.play().catch((err) => console.log('Audio play failed:', err));
  } catch (err) {
    console.log('Audio creation failed:', err);
  }
}

export function triggerHapticFeedback() {
  try {
    if (navigator.vibrate) navigator.vibrate(200);
  } catch (err) {
    console.log('Haptic feedback failed:', err);
  }
}

/**
 * Briefly sets a transient on-screen message, auto-clears after `durationMs`.
 * Usage: `showFeedbackMessage(setMsg, '✓ Scanned!')`.
 */
export function showFeedbackMessage(setMessage, text, durationMs = 1000) {
  setMessage(text);
  setTimeout(() => setMessage(''), durationMs);
}
